import { BoxContainer, BoxContainerProps, CircleIcon, ReactIcons } from "@kalyzee/kalyzee-ui";

import workBoxStyles from "./WorkBox.module.css";
import styles from "./PlayerWorkBox.module.css";
import React from "react";
import clsx from "clsx";
import { RecordIndicator } from "../utils/RecordIndicator";

export interface PlayerWorkBoxProps {
  children: React.ReactNode;
  label: string;
  labelInfo?: string;
  overlayMode?: BoxContainerProps["mode"];
  overlayContent?: React.ReactNode;
  extraHeaderContent?: React.ReactNode;
  className?: string;
  audio?: boolean;
  video?: boolean;
  isMe?: boolean;
  nativeProps?: React.HTMLAttributes<HTMLDivElement>;
  onChangeAudio?: () => void;
  onChangeVideo?: () => void;
}

export const PlayerWorkBox: React.FC<PlayerWorkBoxProps> = ({
  children,
  label,
  labelInfo,
  overlayMode,
  overlayContent,
  extraHeaderContent,
  className,
  audio,
  video,
  isMe,
  nativeProps,
  onChangeAudio,
  onChangeVideo,
}) => {
  const left: React.ReactNode[] = [];
  if (extraHeaderContent) {
    left.push(extraHeaderContent);
  }
  left.push(<span key="label" className={workBoxStyles.label}>{label}</span>);
  if (labelInfo) {
    left.push(
      <span key="youLabel" className={workBoxStyles.labelInfo}>{labelInfo}</span>
    );
  }
  if (isMe) {
    left.push(<RecordIndicator key="recordIndicator" animated={false} />);
  }

  const right: React.ReactNode[] = [];
  if (video !== undefined) {
    right.push(
      <CircleIcon.Variants.Camera
        style={{ fontSize: "0.75em" }}
        key="video"
        disabled={!video}
        onClick={onChangeVideo}
      />
    )
  }
  if (audio !== undefined) {
    right.push(
      <CircleIcon.Variants.Mic
        style={{ fontSize: "0.75em" }}
        key="audio"
        disabled={!audio}
        onClick={onChangeAudio}
      />
    )
  }
  
  return (
    <BoxContainer
      className={clsx([styles.container, className])}
      topBarProps={{
        left,
        right: right.length ? right : undefined,
        className: styles.topBar,
      }}
      mode={overlayMode}
      overlayContent={overlayContent}
      nativeProps={nativeProps}
    >
      {children}
    </BoxContainer>
  );
};
